import { getUrlParamsByObject } from 'Utils/url';
import { httpClientUser } from './microservice-http-clients';

export const addFarmToWatch = id => httpClientUser.post('/watch', { farm_id: id });
export const removeFarmFromWatch = id => httpClientUser.delete('/watch', { farm_id: id });
export const getWallet = (investmentProfileId) => {
  const prePath = investmentProfileId ? `/investment-profile/${investmentProfileId}` : '';
  return httpClientUser.get(`${prePath}/wallet`);
};
export const removeWalletBankAccount = (data, investmentProfileId) => {
  const prePath = investmentProfileId ? `/investment-profile/${investmentProfileId}` : '';
  return httpClientUser.delete(`${prePath}/funding-source`, data);
};
export const addFundingSource = (source, investmentProfileId) => {
  const prePath = investmentProfileId ? `/investment-profile/${investmentProfileId}` : '';
  return httpClientUser.post(`${prePath}/funding-source`, source);
};
export const getWalletTransactions = (limit, offset, investmentProfileId) => {
  const prePath = investmentProfileId ? `/investment-profile/${investmentProfileId}` : '';
  return httpClientUser.get(`${prePath}/wallet/transaction${getUrlParamsByObject({ limit, offset })}`);
};
export const cancelDwollaTransaction = (id, investmentProfileId) => {
  const prePath = investmentProfileId ? `/investment-profile/${investmentProfileId}` : '';
  return httpClientUser.delete(`${prePath}/wallet/transaction`, { id });
};
export const getVerificationData = () => httpClientUser.get('/verification');
export const getBeneficialOwners = profileId => httpClientUser.get(`/investment-profile/${profileId}/verification/beneficial-owner`);
export const getInvestmentProfile = profileId => httpClientUser.get(`/investment-profile/${profileId}`);
